import { useMemo } from "react";
import { useLocation } from "react-router-dom";
import { parse as extractQueryParams } from "query-string";

export default function useUrlQueryParams() {
  const location = useLocation();

  const queryParams = useMemo(() => {
    const query = extractQueryParams(location.search);
    const hash = extractQueryParams(location.hash);
    return { ...query, ...hash };
  }, [location.hash, location.search]);

  return queryParams;
}
